import React, {FunctionComponent, useState} from "react";
import {makeStyles} from "tss-react/mui";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {DRAWER_WIDTH, DRAWER_WIDTH_CLOSED} from "@/Components/Sidebar/Constants";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import {Link, useHistory, useLocation} from "react-router-dom";
import Logo from "@/Style/crentweb-logo.png";
import {CLOSE_SIDEBAR, OPEN_SIDEBAR} from "@/Redux/App/AppConstants";
import {Drawer, FormControlLabel, Theme} from "@mui/material";
import {useAppDispatch, useAppSelector} from "@/Redux/Redux";
import _ from "lodash";
import {AUTH_LOGOUT_SAGA} from "@/Redux/Auth/AuthConstants";
import MuiSelect from "@mui/material/Select";
import {useSelector} from "react-redux";
import {selectViewerEnabledStations, ViewerState} from "@/Redux/Auth/AuthReducer";
import {CHANGE_STATION_START} from "@/Redux/Disposition/Constants";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface SidebarProps {
}

const useStyles = makeStyles()((theme: Theme) => ({
    drawerOpen: {
        width: DRAWER_WIDTH,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: 0,
        }),
    },

    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: 0,
        }),
        overflowX: "hidden",
        width: DRAWER_WIDTH_CLOSED,
    },

    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        //...theme.mixins.toolbar,
    },

    customerLogo: {
        marginLeft: "auto",
        marginRight: "auto",
    },

    listItem: {
        color: "#fff",
    },

    listItemIcon: {
        color: "#fff !important",
    },

    fixedBottom: {
        position: "absolute",
        right: 0,
        left: 0,
        bottom: 0,
        zIndex: 1030,
    },

    crwLogo: {
        padding: ".75rem 1.25rem",
        textAlign: "center",
    },

    version: {
        width: "100%",
        marginBottom: 10,
        textAlign: "center",
    },

    nested: {
        paddingLeft: theme.spacing(4),
    },

    active: {
        backgroundColor: "#e42022!important",
        borderColor: "#e42022!important",
        fontWeight: 600,
    },
    select: {
        paddingTop: 0,
        paddingBottom: 0,
        color: "white",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "white !important",
        },
        "& .MuiNativeSelect-icon": {
            color: "white",
        },
    },

}));

const Sidebar70447: FunctionComponent<SidebarProps> = (): JSX.Element => {
    const {classes, cx} = useStyles();
    const dispatch = useAppDispatch();
    const app = useAppSelector((state) => state.app);
    const user = useAppSelector((state) => state.user);
    const [configurationOpen, setConfigurationOpen] = useState(false);
    const history = useHistory();
    const [mandantLogo, setMandantLogo] = useState(app.mandant?.data?.logo);

    const toggleDrawer = () => {
        if (app.sidebarIsOpen) {
            dispatch({type: CLOSE_SIDEBAR});
        } else {
            dispatch({type: OPEN_SIDEBAR});
        }
    };

    const location = useLocation();
    const {t} = useTranslation();

    function handleLogout() {
        dispatch({type: AUTH_LOGOUT_SAGA});
    }

    const isActive = (pathname: string) => {
        return _.includes(location.pathname, pathname);
        //return pathname === location.pathname;
    };
    const appDispatch = useAppDispatch();
    const {selectedStation} = useAppSelector((state) => state.disposition);
    const enabledStations = useSelector((state) =>
        selectViewerEnabledStations(state as ViewerState)
    );
    const renderSelect = () => {
        return (
            <MuiSelect
                className={classes.select}
                variant={"outlined"}
                size={"small"}
                //style={{height: 'calc(1.5em + .5rem)'}}
                style={{
                    color: "white",
                    borderColor: "white !important",
                }}
                native
                value={selectedStation || ""}
                sx={{
                    '& option': {
                        backgroundColor: "#2f333e !important"
                    }
                }}
                onChange={(e) => {
                    appDispatch({
                        type: CHANGE_STATION_START,
                        payload: e.target.value,
                    });
                }}
            >
                {enabledStations
                    .filter(
                        (station: any) => station.isChangeableInDispo == "J"
                    )
                    .map((station: { stationId: string; name: string }) => (
                        <option
                            key={station.stationId}
                            value={station.stationId}
                        >
                            {station.stationId} - {station.name}
                        </option>
                    ))}
            </MuiSelect>
        );
    };


    return (
        <Drawer
            transitionDuration={0}
            id="sidebar"
            variant="permanent"
            className={cx({
                [classes.drawerOpen]: app.sidebarIsOpen,
                [classes.drawerClose]: !app.sidebarIsOpen,
            })}
            classes={{
                paper: cx({
                    [classes.drawerOpen]: app.sidebarIsOpen,
                    [classes.drawerClose]: !app.sidebarIsOpen,
                }),
            }}
        >
            <div className={classes.toolbar}>
                <IconButton
                    className={classes.listItemIcon}
                    onClick={toggleDrawer}
                >
                    {!app.sidebarIsOpen ? (
                        <ArrowForwardIcon/>
                    ) : (
                        <ArrowBackIcon/>
                    )}
                </IconButton>
            </div>
            <div className={classes.customerLogo}>
                {app.initialized && app.sidebarIsOpen && (
                    <img
                        className="mand-menu-collapsed"
                        src={mandantLogo}
                        alt="Mandant Logo"
                        style={{width: "100%"}}
                    />
                )}
            </div>
            <FormControlLabel
                style={{
                    fontSize: ".875rem !important",
                    color: "white",
                }}
                control={renderSelect()}
                label={t("disposition.controls.rentalAtStation")}
                labelPlacement={"top"}
            />
            <Divider/>

            <List>
                <ListItem
                    button
                    dense
                    key={"disposition"}
                    className={cx(
                        classes.listItem,
                        isActive("/manager/disposition") ? classes.active : "",
                    )}
                    component={Link}
                    to="/manager/disposition"
                >
                    <ListItemIcon className={classes.listItemIcon}>
                        <EventNoteOutlinedIcon/>
                    </ListItemIcon>
                    <ListItemText primary={t("sidebar.disposition")}/>
                </ListItem>
            </List>
            <div className={classes.fixedBottom}>
                <List>
                    {/*<ListItem className={classes.listItem} button onClick={() => {
                            setConfigurationOpen(!configurationOpen)
                        }}>
                            <ListItemIcon className={classes.listItemIcon}>
                                <SettingsIcon/>
                            </ListItemIcon>
                            <ListItemText primary="Konfigurieren"/>
                            {configurationOpen ? <ExpandLess/> : <ExpandMore/>}
                        </ListItem>
                        <Collapse in={configurationOpen} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem className={clsx(classes.listItem, classes.nested)} component={Link}
                                          to="/configuration/stations">
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <EmojiTransportationIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Stationen"/>
                                </ListItem>
                                <ListItem className={clsx(classes.listItem, classes.nested)} component={Link}
                                          to="/configuration/groups">
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <CommuteIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Fahrzeuggruppen"/>
                                </ListItem>
                                <ListItem className={clsx(classes.listItem, classes.nested)} component={Link}
                                          to="/configuration/vehicles">
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <DriveEtaIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Fahrzeuge"/>
                                </ListItem>
                                <ListItem className={clsx(classes.listItem, classes.nested)} component={Link}
                                          to="/configuration/rates">
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <TrendingUpIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Tarife"/>
                                </ListItem>
                                <ListItem className={clsx(classes.listItem, classes.nested)} component={Link}
                                          to="/configuration/users">
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <GroupIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Benutzer"/>
                                </ListItem>
                                <ListItem className={clsx(classes.listItem, classes.nested)} component={Link}
                                          to="/configuration/prints">
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <PrintIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Ausdrucke"/>
                                </ListItem>
                                <ListItem className={clsx(classes.listItem, classes.nested)} component={Link}
                                          to="/configuration/mail">
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <MailIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Mail"/>
                                </ListItem>
                            </List>
                        </Collapse>*/}

                    <ListItem
                        button
                        key={"logout"}
                        className={classes.listItem}
                        onClick={handleLogout}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <ExitToAppOutlinedIcon/>
                        </ListItemIcon>
                        <ListItemText primary={t("sidebar.logout")}/>
                    </ListItem>
                </List>

                <Divider/>
                <div className={classes.crwLogo}>
                    {app.sidebarIsOpen && (
                        <img
                            className="mand-menu-collapsed"
                            src={Logo}
                            alt="CRW Logo"
                            style={{width: "100%"}}
                        />
                    )}
                </div>
                <div className={classes.version}>
                    <p>
                        {t("sidebar.version")} {!app.sidebarIsOpen && <br/>}{" "}
                        {import.meta.env.VITE_VERSION}
                    </p>
                </div>
            </div>
        </Drawer>
    );
};

export default Sidebar70447;
